// Map.js
import './Map.scss';
import { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { CircularProgress } from '@material-ui/core';
import { isEmpty } from '../../utils';
import i18n from '../../i18n';

export default withTranslation()(function Map({ streetNo, streetName, t}) {
    const [ searchDoneEn, setSearchDoneEn ] = useState(false);
    const [ searchDoneTc, setSearchDoneTc ] = useState(false);
    const [ noResultEn, setNoResultEn ] = useState(false);
    const [ noResultTc, setNoResultTc ] = useState(false);
    const haveOneSearchDone = searchDoneEn||searchDoneTc
    const allNoResult = noResultEn&&noResultTc;
    const [ requireMoreData, setRequireMoreData ] = useState(false);
    const [ mapRef, setMapRef ] = useState();
    const [mapID] = useState(`mapid-${new Date().getTime()}`)
    const apikey = '674cf689844d47ffb9b67745488bcb20';

    let languageOptions = ["en", "tc"];
    useEffect(() => {
      // load pin map
      if (streetNo && streetName) {
        const map = initMap();
        setMapRef(map);
        setMarker(map);

        return () => {
          cleanupMap(map)
        }
      } else {
        setRequireMoreData(true);
      }
    }, []);
    useEffect(() => {
      if(haveOneSearchDone){
        mapRef.invalidateSize();
      }
    }, [searchDoneEn, searchDoneTc]);
    
    function initMap() {
      const map = window.L.map(mapID).setView([22.29227, 114.20847], 16);

      window.L.tileLayer(`https://api.hkmapservice.gov.hk/osm/xyz/basemap/WGS84/tile/{z}/{x}/{y}.png?key=${apikey}`, {
        attribution: "<a href='https://api.portal.hkmapservice.gov.hk/disclaimer' target='_blank'>&copy; Map from Lands Department <img src='https://api.hkmapservice.gov.hk/mapapi/landsdlogo.jpg' style='width:25px;height:25px' alt='map' /></a>",
        maxZoom: 19,
        id: 'APIKEY'
      }).addTo(map);
      
      window.L.tileLayer(`https://api.hkmapservice.gov.hk/osm/xyz/label-`+i18n.language+`/WGS84/tile/{z}/{x}/{y}.png?key=${apikey}`, {
        maxZoom: 19,
        id: 'APIKEY'
      }).addTo(map);

      return map
    }

    function cleanupMap(map) {
      if (map && map.remove) {
        map.off();
        map.remove()
      }
    }

    function setSearchDoneWithLang(lang, isSearchDone){
      switch (lang) {
        case "en":
          setSearchDoneEn(isSearchDone);
          break;
        case "tc":
          setSearchDoneTc(isSearchDone);
          break;
        default:
          break;
      }
    }

    function setNoResultWithLang(lang, isNoResult){
      switch (lang) {
        case "en":
          setNoResultEn(isNoResult);
          break;
        case "tc":
          setNoResultTc(isNoResult);
          break;
        default:
          break;
      }
    }
    
    // set marker and pan 
    function setMarker(map) {
      languageOptions.forEach((lang)=>{
        const queryString = "?f=json&outFields=*"+"&maxLocations=20"+"&outSR=4326"+"&key="+apikey+"&SingleLine="+streetNo + ' ' + streetName;
        const findAddressUrl = `https://api.hkmapservice.gov.hk/ags/gc/loc/address/${lang}/findAddressCandidates${queryString}`;

        fetch(findAddressUrl)
        .then((result)=>(result.json()))
        .then((addresses)=>{
          const { candidates } = addresses;
          if (candidates.length === 0) {
            setNoResultWithLang(lang, true);
            return addresses;
          } 
          if (candidates && candidates[0]) {
            setSearchDoneWithLang(lang, true);
            const {
              location: {x, y},
              address
            } = candidates[0];
          
            window.L.marker({lon:x, lat:y})
            .addTo(map)
            .bindTooltip(address)
            .openTooltip();
            
            map.panTo({lon:x, lat:y})
            return
          } else {
            setNoResultWithLang(lang, true);
            return
          }
        })
      })
    }
    
    return (
      requireMoreData?<div><h1 className="center-content">{t("step3.location.searchError")}</h1></div>:
      allNoResult?<div><h1 className="center-content">{t("step3.location.noResult")}</h1></div>:
      <div className="leaflet-map">
        <div id={mapID} className={"leaflet-map"+(haveOneSearchDone?"":" hidden")}></div>
        <div className="center-content">{haveOneSearchDone?"":<CircularProgress/>}</div>
      </div>
    )
})
